module.exports = __webpack_public_path__ + "img/avatar_default_6.4ca0e422.svg";